module.exports = __webpack_public_path__ + "static/media/saiba_mais.fa3e07ec.gif";